<app-table [config]="tableConfig" [filterBar]="filterConfig"></app-table>
